import {
	Component,
	computed,
	inject,
	ChangeDetectionStrategy,
} from '@angular/core';
import { ThemeService, ThemeMode } from '../../../../services/theme.service';
import { ThemeModeIconComponent } from '../jepto-theme-mode-icon/jepto-theme-mode-icon.component';

@Component({
	selector: 'jepto-theme-switcher',
	templateUrl: './theme-switch.component.html',
	styleUrls: ['./theme-switch.component.scss'],
	standalone: true,
	imports: [ThemeModeIconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'jepto-theme-switch' },
})
export class ThemeSwitchComponent {
	private readonly themeService = inject(ThemeService);

	/** User's theme mode preference (auto, light, or dark) */
	readonly themePreference = computed(() =>
		this.themeService.getThemeModePreferenceSignal()()
	);

	/** Whether auto button should show as active */
	readonly isAutoActive = computed(() => this.themePreference() === 'auto');

	/** Whether light button should show as active */
	readonly isLightActive = computed(() => this.themePreference() === 'light');

	/** Whether dark button should show as active */
	readonly isDarkActive = computed(() => this.themePreference() === 'dark');

	setThemeMode(mode: ThemeMode): void {
		this.themeService.setThemeMode(mode);
	}
}
